const config = require("./config");

const languages = ["en", "fr", "it", "de", "es", "nl"].filter((s) => s);

module.exports = languages;